import { useCallback, useMemo } from "react";

import { useQuery } from "hooks";
import { createResolverFactory } from "components/QueryClient/ResolverFactory";

export default function useUseCaseTemplates(titles) {
  const factory = useCallback(() => {
    const query = `
      query templates($titles: [String!]) {
        currentTemplates(section: all, releases_Title_In: $titles) {
          edges {
            node {
              current {
                title
                numWorkflows
              }
              installed {
                title
                numWorkflows
              }
            }
          }
        }
      }`;

    const resolver = ({ data }) => {
      return (data?.currentTemplates?.edges || []).reduce((acc, { node }) => {
        acc[node.installed?.title || node.current?.title] = {
          installed: Boolean(node.installed),
          numWorkflows:
            node.installed?.numWorkflows || node.current?.numWorkflows,
        };
        return acc;
      }, {});
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { loading, data, numOfFetches } = useQuery(
    factory,
    useMemo(() => {
      return { variables: { titles } };
    }, [titles])
  );

  return {
    loadingUseCasesTemplates: loading || numOfFetches === 0,
    useCasesTemplates: data,
  };
}
